import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { ACCELERATORS } from "../data/presets";

const FIELDS = ["cpuCores", "ram", "gpu", "vram", "gpuCount", "accelerator"];
const ACCELS = ACCELERATORS.map((a) => a.id);

export function encodeHardware(hw) {
  const bytes = new TextEncoder().encode(JSON.stringify(Object.fromEntries(FIELDS.map((k) => [k, hw[k]]))));
  let bin = "";
  bytes.forEach((b) => { bin += String.fromCharCode(b); });
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

const num = (v, min, max, def) => (Number.isFinite(Number(v)) ? Math.min(max, Math.max(min, Number(v))) : def);

export function decodeHardware(data) {
  const bin = atob(data.replace(/-/g, "+").replace(/_/g, "/"));
  const raw = JSON.parse(new TextDecoder().decode(Uint8Array.from(bin, (c) => c.charCodeAt(0))));
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) throw new Error("invalid");
  const accelerator = ACCELS.includes(raw.accelerator) ? raw.accelerator : "cpu";
  const noGpu = accelerator === "cpu";
  return {
    cpuCores: Math.round(num(raw.cpuCores, 2, 64, 8)),
    ram: num(raw.ram, 4, 256, 16),
    gpu: noGpu ? "iGPU / aucun" : String(raw.gpu || "GPU inconnu").slice(0, 80),
    vram: noGpu ? 0 : num(raw.vram, 0, 80, 0),
    gpuCount: noGpu ? 1 : Math.round(num(raw.gpuCount, 1, 8, 1)),
    accelerator,
  };
}

export function ShareDiagnosticButton({ hardware }) {
  const share = () => {
    const url = `${window.location.origin}/diagnostic/partage?hw=${encodeHardware(hardware)}`;
    navigator.clipboard.writeText(url).then(() => toast.success("Lien du diagnostic copié"), () => toast.error("Copie impossible"));
  };
  return (
    <Button variant="outline" size="sm" onClick={share} data-testid="diagnostic-share-button" className="gap-1.5">
      <Share2 className="h-4 w-4" /> Partager ma machine
    </Button>
  );
}
